import $ from 'jquery';
import LiveSearchItem from '../template/LiveSearchItem';
import Api from '../util/Api';

let liveSearchTimeout;

$('.live-search-input').on('input', function () {
    if (liveSearchTimeout) {
        clearTimeout(liveSearchTimeout);
    }

    liveSearchTimeout = setTimeout(function () {
        const initialQuery = $('.live-search-input').val();

        if (initialQuery.length >= 3) {
            Api.get('/api/live-search/', {q: initialQuery})
                .then((response) => {
                    const currentQuery = $('.live-search-input').val();

                    if (response.status === 'success' && currentQuery === initialQuery) {
                        $('.live-search-results').empty();

                        response.items.forEach((item) => {
                            $('.live-search-results').append(LiveSearchItem(item));
                        });
                    }
                });
        } else {
            $('.live-search-results').empty();
        }
    }, 500);
});
